module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_trash-91a72ef4c71269ea645b44f7d1953c9e.svg";